import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
var useContextMenuStore = function () { return useContext(MobXProviderContext).contextMenuStore; };
export default useContextMenuStore;
//# sourceMappingURL=UseContextMenuStore.js.map